import SignalRConnection from "./index";

const signalRConnection = new SignalRConnection();

export default signalRConnection;
